const basePath = '/recruiting/personal/reset-password'

export default {
  name: 'personalResetPassword',
  path: `${basePath}`,
  component: null,
  meta: {
    isInclude: false,
    mobileHomeMenu: {
      redirectPath: '/referral/employee-change-password/',
      iconClass: 'iconreset',
      nameI18nKey: 'personal.resetPassword.homeMenu.name',
      descI18nKey: 'personal.resetPassword.homeMenu.desc'
    }
  }
}
